import React from 'react';
import AIAvatar from '../AIAvatar';

/**
 * Floating action button that opens the AI chat panel.
 * Purely presentational — parent owns the `open` state.
 */
export default function ChatFloatingButton({ label, ariaLabel, onClick, testId = 'ai-chat-open-button' }) {
  return (
    <button
      data-testid={testId}
      onClick={onClick}
      aria-label={ariaLabel || label}
      className="rp-advisor-focus animate-fade-in-up fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 group flex items-center gap-2 rounded-full pl-1.5 pr-4 sm:pr-5 py-1.5 bg-white/95 dark:bg-[#0B0E14]/95 backdrop-blur text-[#0F2E5C] dark:text-slate-100 border border-slate-200 dark:border-slate-800 shadow-lg shadow-slate-900/10 dark:shadow-black/40 hover:shadow-xl hover:shadow-emerald-500/10 dark:hover:shadow-emerald-400/10 hover:border-[#12355B] dark:hover:border-[#45C04A] hover:-translate-y-0.5 active:translate-y-0 transition-[transform,box-shadow,border-color] duration-300 ease-out will-change-transform"
    >
      <span className="relative inline-flex" style={{ width: 32, height: 32 }} aria-hidden="true">
        <span className="motion-safe:animate-ping absolute inset-0 rounded-full bg-emerald-400/25 group-hover:bg-emerald-400/40 transition-colors" />
        <AIAvatar
          size={32}
          animate
          className="relative motion-safe:transition-transform motion-safe:duration-300 motion-safe:group-hover:scale-105"
        />
      </span>
      <span className="font-semibold text-sm whitespace-nowrap">{label}</span>
    </button>
  );
}
